<div class="flex flex-col gap-4">
  <section>
    You have been invited to the following
    @if (pendingInvitations$ | async; as invitations) {
      @if (invitations.length > 1) {
        teams:
      } @else {
        team:
      }
    }
  </section>
  <section>
    <p-panel class="_p-panel-without-header overflow-y-auto max-h-80">
      <ul class="list-none flex flex-col gap-2">
        @for (
          invitation of pendingInvitations$ | async;
          track invitation.team.id
        ) {
          <li class="flex items-center gap-2">
            <div class="grow self-center mr-4">
              <div style="line-height: 1.25em">
                <div>
                  {{ invitation.team.name }}
                </div>
                <div class="text-sm opacity-60 whitespace-nowrap">
                  by {{ invitation.creator.email }}
                </div>
              </div>
            </div>
            <dt-team-invitation-buttons [teamId]="invitation.team.id" />
          </li>
        }
      </ul>
    </p-panel>
  </section>
  <section>
    <lib-response-error-box [responseError]="responseError()" />
  </section>
</div>
<div class="flex items-center justify-end gap-2">
  <p-button label="Close" type="button" (click)="close()" outlined="true">
  </p-button>
</div>
